<template>
  <div>
    <a-card
      size="small"
      title="查询"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <template v-slot:extra>
        <!-- <a-button @click="backPage">返回</a-button> -->
      </template>
      <a-form layout="inline" class="topForm">
        <div>
          <a-form-item>
            <a-input
              v-model:value="searchForm.orderNo"
              placeholder="订单编号"
              allowClear
            />
          </a-form-item>

          <a-form-item>
            <a-input
              v-model:value="searchForm.passengerName"
              placeholder="购票人姓名"
              allowClear
            />
          </a-form-item>
          <a-form-item>
            <a-select
              v-model:value="searchForm.checkState"
              placeholder="对账状态"
              style="width: 200px"
              @search="fetchUser"
              @change="change"
              allowClear
            >
              <a-select-option
                v-for="d in checkStateData"
                :key="d.value"
                :value="d.value"
                :label="d.label"
              >
                {{ d.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item v-show="false">
            <a-range-picker
              v-model:value="searchForm.orderdate"
              :placeholder="['账单开始', '账单结束']"
              valueFormat="YYYY-MM-DD"
              format="YYYY-MM-DD"
            />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="searchAction"> 查询 </a-button>
          </a-form-item>
        </div>
        <div>
          <!--<a-form-item>
            <a-button @click="createBill">补充数据</a-button>
          </a-form-item>-->
          <a-form-item>
            <a-button @click="handleDownload">导出</a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="handleFinish">对账完成</a-button>
          </a-form-item>
        </div>
      </a-form>
    </a-card>
    <a-card
      size="small"
      title=""
      style="margin-top: 20px"
      class="log_content"
      :headStyle="{
        background: '#f3f3f3',
      }"
      @tabChange="cardtabChange"
      :tabList="panes"
      :bodyStyle="{
        padding: '0',
      }"
    >
      <a-table
        :columns="columns"
        bordered
        :data-source="list"
        :pagination="false"
        :scroll="{ x: 1300 }"
        :row-key="(r) => r.id"
        :loading="loading"
      >
        <template v-slot:orderNo="{ text, record }">
          <div @click="toDetail(record)">{{ record.orderNo }}</div>
        </template>
        <template v-slot:checkStateValue="{ text, record }">
          <div :class="{ redClass: record.checkState == 90 }">
            {{ record.checkStateValue }}
          </div>
        </template>

        <template v-slot:settlementAmount="{ text, record }">
          <div
            v-if="record.settlementAmount != null"
            :class="{ redClass: record.settlementAmount < 0 }"
          >
            ¥ {{ record.settlementAmount }}
          </div>
        </template>

        <template v-slot:ticketAmount="{ text, record }">
          <div v-if="record.ticketAmount != null">
            ¥ {{ record.ticketAmount }}
          </div>
        </template>

        <template v-slot:postAmount="{ text, record }">
          <div v-if="record.postAmount != null">¥ {{ record.postAmount }}</div>
        </template>

        <template v-slot:insuranceAmount="{ text, record }">
          <div v-if="record.insuranceAmount != null">
            ¥ {{ record.insuranceAmount }}
          </div>
        </template>

        <template v-slot:returnServiceAmount="{ text, record }">
          <div v-if="record.returnServiceAmount != null">
            ¥ {{ record.returnServiceAmount }}
          </div>
        </template>

        <template v-slot:serviceAmount="{ text, record }">
          <div v-if="record.settlementAmount != null">
            ¥ {{ record.serviceAmount }}
          </div>
        </template>

        <template v-slot:checkDate="{ text, record }">
          <div>{{ record.checkBegin + " 至 " + record.checkEnd }}</div>
        </template>

        <template v-slot:operation="{ text, record }">
          <a-button
            type="danger"
            @click="handleDelete(record)"
            size="small"
            style="margin-right: 10px"
            v-show="record.importId != null"
          >
            删除
          </a-button>
        </template>
      </a-table>
    </a-card>

    <!-- 导入对账单 -->
    <a-modal v-model:visible="createVisible" title="导入对账单" :footer="null">
      <a-spin :spinning="createSpinning">
        <a-form layout="inline">
          <a-row
            type="flex"
            justify="space-around"
            align="middle"
            class="creatRow"
          >
            <a-col :span="4">
              <CloudDownloadOutlined />
            </a-col>
            <a-col :span="20">
              <p>填写导入数据信息</p>
              <p>
                请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除
              </p>
              <p @click="templateDownload" style="color: #1bba79">下载模板</p>
            </a-col>
          </a-row>
          <a-row
            type="flex"
            justify="space-around"
            align="middle"
            class="creatRow"
          >
            <a-col :span="4">
              <CloudUploadOutlined />
            </a-col>
            <a-col :span="20">
              <p>上传填好的信息表</p>
              <p>
                文件后缀名必须为xls 或xlsx
                （即Excel格式），文件大小不得大于10M，最多支持导入3000条数据
              </p>
              <a-upload
                :fileList="fileList"
                :remove="handleRemove"
                :beforeUpload="beforeUpload"
              >
                <p class="handle" style="color: #1bba79; font-weight: normal">
                  上传文件
                </p>
              </a-upload>
            </a-col>
          </a-row>
          <a-row
            type="flex"
            justify="space-around"
            align="middle"
            class="tipRow"
          >
            <a-col :span="3">
              <ExclamationCircleOutlined />
            </a-col>
            <a-col :span="21">
              <p>特别提示</p>
              <p>单号不能重复</p>
            </a-col>
          </a-row>

          <a-form-item>
            <a-button type="primary" @click="createCancel"> 取消 </a-button>
          </a-form-item>
          <a-form-item>
            <a-button @click="handleUpload">上传</a-button>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>

    <df-pagination :model="pageObj"></df-pagination>
  </div>
</template>

<script>
import { ref, reactive, provide, createVNode } from "vue";
import financialApi from "@axios/financial";
import { Modal, destroyAll, notification, message } from "ant-design-vue";
import { useRoute, useRouter } from "vue-router";
import {
  CloudDownloadOutlined,
  CloudUploadOutlined,
  ExclamationCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons-vue";
import { exportOut } from "@axios/exportOut";
export default {
  name: "insurance",
  components: {
    CloudDownloadOutlined,
    CloudUploadOutlined,
    ExclamationCircleOutlined,
    UploadOutlined,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const billNo = route.query.billNo;
    const orderNo = '';
    const id = route.query.id;
    const supplierId = route.query.supplierId;
    const checkBegin = route.query.checkBegin;
    const checkEnd = route.query.checkEnd;

    let activeKey = ref("0");
    let searchForm = reactive({
      billNo: "",
        orderNo: "",
      passengerName: "",
      checkState: "",
      orderdate: [],
    });

    let searchParams = reactive({
      billNo: "",
      passengerName: "",
      checkState: "",
        orderNo: "",
    });

    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });

    const searchAction = () => {
      searchParams.billNo = searchForm.billNo;
      searchParams.passengerName = searchForm.passengerName;
      searchParams.checkState = searchForm.checkState;
      searchParams.orderNo = searchForm.orderNo;
      if (searchForm.orderdate) {
        searchParams.tktsStartTime = searchForm.orderdate[0];
        searchParams.tktsEndTime = searchForm.orderdate[1];
      } else {
        searchParams.tktsStartTime = "";
        searchParams.tktsEndTime = "";
      }

      pageObj.value = {
        page: 1,
        rows: 10,
        totle: 1,
      };
      getList();
    };

    let list = ref([]);

    let loading = ref(false);

    const getList = () => {
      let params = {
          orderType: activeKey.value == "0" ? null : activeKey.value,
        billNo: searchParams.billNo ? searchParams.billNo : billNo,
          orderNo: searchParams.orderNo ? searchParams.orderNo : orderNo,
        passengerName: searchParams.passengerName
          ? searchParams.passengerName
          : null,
        checkState: searchParams.checkState ? searchParams.checkState : null,
        // checkBegin: searchParams.tktsStartTime ? searchParams.tktsStartTime : null,
        // checkEnd: searchParams.tktsEndTime ? searchParams.tktsEndTime : null,
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
      };

      loading.value = true;

      financialApi.getSupplierDetail(params).then((res) => {
        console.log(res);
        loading.value = false;
        if (!res) return;
        pageObj.value.totle = res.total;
        pageObj.value.page = res.page;
        list.value = res.data;
      });
    };

    getList();

    const reset = () => {
      searchForm.supplierId = "";
      searchForm.orderdate = [];

      searchAction();
    };

    const pageChange = (page) => {
      pageObj.value.page = page;
      getList();
    };

    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      getList();
    };

    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);

    // 补充数据
    let createVisible = ref(false);
    const createBill = () => {
      createVisible.value = true;
    };
    let createForm = reactive({
      orderdate: [],
    });

    let createParams = reactive({
      tktsStartTime: "",
      tktsEndTime: "",
    });
    const createCancel = () => {
      createVisible.value = false;
    };
    // 下载模板
    const templateDownload = () => {
      let params = {};
      let fileName = "模板";
      exportOut(
        params, // 导出请求参数
        "/app-finance/supplier/bill/download/template", // 接口地址
        fileName // 导出文件名字
      );
    };
    // 文件上传
    let createSpinning = ref(false);
    let fileList = ref([]);
    const handleRemove = (file) => {
      // 移除文件时，要重新给fileList赋值
      let arr = [];
      for (let i = 0; i < fileList.value.length; i++) {
        if (fileList.value[i].uid !== file.uid) {
          arr.push(fileList.value[i]);
        }
      }
      fileList.value = arr;
      console.log(fileList.value);
    };
    // 上传前校验
    const beforeUpload = (file) => {
      console.log(file);
      // const isXlsOrXlsx = file.type === "xls" || file.type === "xlsx";
      // if (!isXlsOrXlsx) {
      //   message.error("只能上传xls 或xlsx （即Excel格式）!");
      // }
      // const isLt10M = file.size / 1024 / 1024 < 10;
      // if (!isLt10M) {
      //   message.error("文件大小不得大于10M!");
      // }
      // return isXlsOrXlsx && isLt10M;
      fileList.value = [...fileList.value, file];
      return false;
    };
    // 上传
    const handleUpload = () => {
      createSpinning.value = true;
      console.log(fileList.value);
      const formData = new FormData();
      fileList.value.forEach((file) => {
        formData.append("file", file);
        console.log(file);
      });
      formData.append("supplierId", supplierId);
      formData.append("checkBegin", checkBegin);
      formData.append("checkEnd", checkEnd);
      financialApi.createBill(formData).then((res) => {
        console.log(res);
        fileList.value = [];
        message.success("上传成功");
        createSpinning.value = false;
        createVisible.value = false;
        getList();
      });
    };

    // 删除供应明细
    const handleDelete = (item) => {
      console.log(item);
      Modal.confirm({
        title: "是否确认删除？",
        icon: createVNode(ExclamationCircleOutlined),
        content: "",
        onOk() {
          financialApi.delSupplierDetail(item.importId).then((res) => {
            console.log(res);
            message.success("删除成功");
            getList();
          });
        },
        onCancel() {},
      });
    };

    let panes = ref([
      { tab: "全部", key: "0" },
      { tab: "出票", key: "10" },
      { tab: "改签", key: "20" },
      { tab: "退票", key: "30" },
    ]);
    const getSupplierTicketCount = () => {
      let params = {
        billNo: billNo,
      };
      financialApi.getSupplierTicketCount(params).then((res) => {
        console.log(res);
        panes.value = [
          { tab: `全部`, key: "0" },
          { tab: `出票(${res.buyType})`, key: "10" },
          { tab: `改签(${res.changesType})`, key: "20" },
          { tab: `退票(${res.returnType})`, key: "30" },
        ];
      });
    };
    getSupplierTicketCount();

    const cardtabChange = (key) => {
      activeKey.value = key;
      reset();
    };

    const backPage = () => {
      router.back();
    };

    // 导出
    const handleDownload = () => {
      let params = {
        billNo: billNo,
      };
      let fileName = "供应结算单明细-" + billNo;
      exportOut(
        params, // 导出请求参数
        "/app-finance/supplier/bill/download", // 接口地址
        fileName // 导出文件名字
      );
    };

    // 对账完成
    const handleFinish = () => {
      Modal.confirm({
        title: "是否确认对账完成？",
        icon: createVNode(ExclamationCircleOutlined),
        content: "",
        onOk() {
          financialApi.supplierFinish(id).then((res) => {
            console.log(res);
            message.success("对账完成");
            getList();
          });
        },
        onCancel() {},
      });
    };

    const toDetail = (row) => {
      router.push({
        name: "orderDetail",
        query: {
          code: row.orderNo,
          type: "nomalOrder",
        },
      });
    };

    return {
      activeKey,
      cardtabChange,
      panes,
      handleDelete,
      loading,
      list,
      pageObj,
      searchForm,
      searchAction,
      reset,
      columns: [
        {
          title: "对账状态",
          dataIndex: "checkStateValue",
          width: 100,
          align: "center",
          slots: { customRender: "checkStateValue" },
          fixed: "left",
        },
        {
          title: "异常原因",
          dataIndex: "exReason",
          width: 150,
          align: "center",
          slots: { customRender: "exReason" },
          fixed: "left",
        },
        {
          title: "结算时间",
          dataIndex: "settlementTime",
          width: 160,
          align: "center",
          fixed: "left",
        },
        {
          title: "订单号",
          dataIndex: "orderNo",
          width: 120,
          align: "center",
          className: `${"underlineStyle"}`,
          fixed: "left",
          slots: { customRender: "orderNo" },
        },
          {
              title: "原单号",
              dataIndex: "originalOrderCode",
              width: 100,
              fixed: "left",
              align: "center",
          },
          {
              title: "退票单",
              dataIndex: "returnNo",
              width: 100,
              fixed: "left",
              align: "center",
          },
          {
              title: "供应订单号",
              dataIndex: "supplierOrderNo",
              width: 120,
              fixed: "left",
              align: "center",
          },
          {
              title: "票种类型",
              dataIndex: "orderTypeValue",
              width: 100,
              align: "center",
          },
          {
              title: "改签类型",
              dataIndex: "changeTypeValue",
              width: 120,
              align: "center",
          },
          {
              title: "供应商名称",
              dataIndex: "supplierName",
              width: 100,
              align: "center",
          },
          {
              title: "渠道名称",
              dataIndex: "distributorName",
              width: 100,
              align: "center",
          },
          {
              title: "渠道单号",
              dataIndex: "channelCode",
              width: 100,
              align: "center",
          },
          {
              title: "结算金额",
              dataIndex: "settlementAmount",
              width: 120,
              align: "center",
              slots: { customRender: "settlementAmount" },
              className: `${"columnStyle"}`,
             // fixed: "left",
          },
          {
              title: "票款",
              dataIndex: "ticketAmount",
              width: 100,
              align: "center",
              slots: { customRender: "ticketAmount" },
          },
          /*{
              title: "手续费",
              dataIndex: "ticketAmount",
              width: 100,
              align: "center",
              slots: { customRender: "ticketAmount" },
          },*/
          /*{
              title: "邮寄费",
              dataIndex: "postAmount",
              width: 100,
              align: "center",
              slots: { customRender: "postAmount" },
          },
          {
              title: "保险费",
              dataIndex: "insuranceAmount",
              width: 100,
              align: "center",
              slots: { customRender: "insuranceAmount" },
          },
          {
              title: "保险数量",
              dataIndex: "insuranceCount",
              width: 100,
              align: "center",
          },
          {
              title: "服务费",
              dataIndex: "serviceAmount",
              width: 100,
              align: "center",
              slots: { customRender: "serviceAmount" },
          },*/
        {
          title: "票号",
          dataIndex: "ticketNo",
          width: 120,
          align: "center",
          //fixed: "left",
        },
          {
              title: "票数",
              dataIndex: "ticketCount",
              width: 100,
              align: "center",
          },
          {
              title: "手续费",
              dataIndex: "returnServiceAmount",
              width: 100,
              align: "center",
              slots: { customRender: "returnServiceAmount" },
          },
          {
              title: "出票模式",
              dataIndex: "ticketModeValue",
              width: 100,
              align: "center",
          },
          {
              title: "出票方式",
              dataIndex: "ticketWayValue",
              width: 100,
              align: "center",
          },
          {
              title: "乘客姓名",
              dataIndex: "passengerName",
              width: 100,
              align: "center",
          },
          {
              title: "车次号",
              dataIndex: "trainNo",
              width: 100,
              align: "center",
          },
          {
              title: "出发站",
              dataIndex: "fromStation",
              width: 100,
              align: "center",
          },
          {
              title: "到达站",
              dataIndex: "toStation",
              width: 100,
              align: "center",
          },
          {
              title: "发车时间",
              dataIndex: "trainFromTime",
              width: 150,
              align: "center",
          },
          {
              title: "到达时间",
              dataIndex: "trainToTime",
              width: 150,
              align: "center",
          },
          {
              title: "是否打印票根",
              dataIndex: "enterpriseCodeValue",
              width: 100,
              align: "center",
          },
          /*{
              title: "退票唯一单号",
              dataIndex: "returnUniqueNo",
              width: 200,
              align: "center",
          },*/
          {
              title: "操作",
              dataIndex: "",
              width: 100,
              align: "center",
              slots: { customRender: "operation" },
              fixed: "right",
          },


        /*{
          title: "是否抢票",
          dataIndex: "isGrabTicketValue",
          width: 100,
          align: "center",
        {
          title: "手续费",
          dataIndex: "returnServiceAmount",
          width: 100,
          align: "center",
          slots: { customRender: "returnServiceAmount" },
        },
        {
          title: "改签单",
          dataIndex: "changesNo",
          width: 100,
          align: "center",
        },
        {
          title: "出票单",
          dataIndex: "orderNo",
          width: 100,
          align: "center",
        },*/
      ],
      checkStateData: [
        {
          label: "未对账",
          value: "10",
        },
        {
          label: "已对账",
          value: "20",
        },
        {
          label: "异常",
          value: "90",
        },
      ],
      backPage,
      handleDownload,
      handleFinish,
      createBill,
      createVisible,
      createForm,
      createParams,
      templateDownload,
      createCancel,
      fileList,
      beforeUpload,
      handleRemove,
      handleUpload,
      createSpinning,
      toDetail,
    };
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.table_logo {
  width: 70px;
}
.creatRow {
  border: 1px solid #f5f5f5;
  margin-bottom: 15px;
  .ant-col-4 {
    text-align: center;
    font-size: 30px;
  }
  p {
    line-height: 1.5;
    margin: 10px 0;
    &:nth-of-type(1) {
      font-weight: bold;
    }
    &:nth-of-type(2) {
      font-size: 12px;
      color: #666;
    }
    &:nth-of-type(3) {
      color: #40a9ff;
      cursor: pointer;
    }
  }
  .handle {
    line-height: 1.5;
    margin-top: 0;
    margin-bottom: 10px;
    color: #40a9ff;
    cursor: pointer;
  }
}
.tipRow {
  border: 1px solid #ffe58f;
  margin-bottom: 15px;
  background: #fffbe6;
  color: #888;
  .ant-col-3 {
    text-align: center;
    font-size: 20px;
  }
  p {
    line-height: 1.5;
    margin: 10px 0;
    &:nth-of-type(1) {
      font-weight: bold;
    }
    &:nth-of-type(2) {
      font-size: 12px;
    }
  }
}
.log_content {
  .redClass {
    color: red;
  }
}
.topForm {
  display: flex;
  justify-content: space-between;
}
</style>
